import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { Container, Grid, Paper, CircularProgress } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { MaterialCurrency } from 'Components/Inputes/MaterialCurrencyField';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import Divider from '@material-ui/core/Divider';

import {
    BankToOtherTransfer as TRANSFER,
    SelectAccountSummery as SELECT,
    SelectBeneficiary as SELECT_BENE,
    SelectBeneByID as SELECT_BY_ID
} from 'Components/Api/CreditInstitutionSettingAPI';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import CustomRadioButton from 'Components/Inputes/CustomRadioButton';
import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';

const CustomContainer = HOCLoader(Container);

export const BankToOtherTransfer = () => {
    const classes = commonStyle();
    const formRef = useRef();
    const [responseMessage, setResponseMessage] = useState('');

    const [accountType, setAccountType] = useState('');
    const [accountNo, setAccountNo] = useState('');
    const [balance, setBalance] = useState('');
    const [beneAccountNo, setBeneAccountNo] = useState('');
    const [iFSCCode, setIFSCCode] = useState('');
    const [branchName, setBranchName] = useState('');
    const [itemList, setItemList] = useState([]);

    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [currentUserID] = useState(parseInt(localStorage.getItem('UserID')));
    const [formObj, setFormObj] = useState({
        Amount: '',
        BankName: 0,
        b_Id: '',
        Mode: 'IMPS',
        Item: ''
    });

    const reset = () => {
        setFormObj({
            Amount: '',
        });
        setBeneAccountNo('');
        setBranchName('');

    };

    useEffect(() => {
        select();
        selectDetails();
    }, []);

    const validationSchema = Yup.object({

        Amount: Yup.number()
            .moreThan(0, PLEASE_PROVIDE_VALID + 'amount')
            .required(PLEASE_PROVIDE_VALID + 'amount'),

    });

    const select = async () => {
        const { isAuthorized, status, data } = await SELECT();

        if (!isAuthorized) LOGOUT();

        if (!status) {
            setResponseMessage(data);
            setIsError(true);
            return;
        }

        var d = JSON.parse(data);
        setAccountType(d.AccountType);
        setAccountNo(d.AccountNo);
        setBalance(d.Balance);
    };

    const selectBeneByID = async (b_Id) => {
        const inputObj = {
            b_Id: b_Id,
        };
        var reqObj = JSON.stringify(inputObj);

        const { isAuthorized, status, data } = await SELECT_BY_ID(reqObj);

        if (!isAuthorized) LOGOUT();

        if (!status) {
            setResponseMessage(data);
            setIsError(true);
            return;
        }

        var d = JSON.parse(data);
        setBranchName(d.BranchName);
        setBeneAccountNo(d.AccountNo);
        setIFSCCode(d.IFSCCode);
    };

    const selectDetails = async () => {

        var requestJSON = JSON.stringify();
        setIsError(false);
        setLoadingOpen(true);
        const response = await SELECT_BENE(requestJSON);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }

        var data = JSON.parse(response.data);

        setItemList(data.Beneficiary);
    }

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setSubmitting(false);

        const inputObj = {
            IFSC: iFSCCode,
            AccNo: accountNo,
            Name: values.Item.name,
            BeneAccNo: beneAccountNo,
            Amount: values.Amount,
            Type: values.Mode
        };
        var reqObj = JSON.stringify(inputObj);

        setLoadingOpen(true);

        var response = await TRANSFER(reqObj);

        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);
        if (!response.status) {
            setSeverity('error');
            return;
        }
        reset();
        resetForm();
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={submithandle}
                resetForm={formObj}
                render={({ formProps, values, setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <h2 className={classes.PaperHead_h2}>Bank To Other Bank</h2>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={6}
                                lg={6}
                                style={{
                                    display: 'flex',
                                    direction: 'rtl'
                                }}
                            >

                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <Paper className={classes.PaperStyle}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <span style={{ fontSize: '16px', fontWeight: '600' }}>
                                                    Transfer Mode
                                                </span>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>

                                                <CustomRadioButton
                                                    label="IMPS"
                                                    name="Mode"
                                                    displayValueID="IMPS"
                                                    isSelected={
                                                        values.Mode === 'IMPS'
                                                    }
                                                    onChange={(value) =>
                                                        setFieldValue(
                                                            'Mode',
                                                            value
                                                        )
                                                    }
                                                />


                                                <CustomRadioButton
                                                    label="NEFT"
                                                    name="Mode"
                                                    displayValueID="NEFT"
                                                    isSelected={
                                                        values.Mode === 'NEFT'
                                                    }
                                                    onChange={(value) =>
                                                        setFieldValue(
                                                            'Mode',
                                                            value
                                                        )
                                                    }
                                                />

                                                <CustomRadioButton
                                                    label="RTGS"
                                                    name="Mode"
                                                    displayValueID="RTGS"
                                                    isSelected={
                                                        values.Mode === 'RTGS'
                                                    }
                                                    onChange={(value) =>
                                                        setFieldValue(
                                                            'Mode',
                                                            value
                                                        )
                                                    }
                                                />


                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <span style={{ fontSize: '20px', fontWeight: '600' }}>
                                                    Debit From Account
                                                </span>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <span style={{ fontSize: '16px', fontWeight: '600' }}>
                                                    Account Type:  {accountType}
                                                </span>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>

                                                <span style={{ fontSize: '16px', fontWeight: '600' }}>
                                                    Account No:  {accountNo}

                                                </span>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>

                                                <span style={{ fontSize: '16px', fontWeight: '600' }}>
                                                    Balance:  {balance}

                                                </span>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <span style={{ fontSize: '20px', fontWeight: '600' }}>
                                                    Credit To Account
                                                </span>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <Field
                                                    component={AutoCompleteTextView}
                                                    name="Item"
                                                    options={itemList}
                                                    getOptionLabel={(option) => option.name}
                                                    getOptionSelected={(option, value) => option.name === value.name}
                                                    textFieldProps={{
                                                        label: 'Select Beneficiary'
                                                    }}
                                                    onCustomCallback={(name, value) => {
                                                        setFieldValue('Item.b_Id', value.b_Id);
                                                        setFieldValue('Item.name', value.name);
                                                        selectBeneByID(value.b_Id);
                                                    }}
                                                />

                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <span style={{ fontSize: '16px', fontWeight: '600' }}>
                                                    Account Number:  {beneAccountNo}
                                                </span>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>

                                                <span style={{ fontSize: '16px', fontWeight: '600' }}>
                                                    Branch Name:  {branchName}

                                                </span>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <MaterialCurrency
                                                    name="Amount"
                                                    label="Amount(₹)"
                                                    placeholder="Amount(₹)"
                                                    autoComplete="new-password"
                                                    max={9999999}

                                                />
                                            </Grid>


                                        </Grid>

                                        <Divider variant="middle" className="rechdevider" />

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            spacing={2}
                                            container
                                            className={classes.footerGrid}
                                        >
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <SecondaryButton
                                                    type="reset"
                                                    variant="contained"
                                                    color="secondary"
                                                    title="Reset"
                                                    className={
                                                        classes.CustomDangerButtonStyle
                                                    }
                                                    onClick={(e) => reset()}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <PrimaryButton
                                                    type="submit"
                                                    title="Submit"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loadingOpen}
                                                />
                                                {loadingOpen && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={classes.buttonProgress}
                                                    />
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Form>
                            </Grid>

                        </Grid>


                    );
                }}
            />
        </CustomContainer>
    );

};